import { gql } from '@apollo/client';
import { User } from '../../queries/users/types';
import { UpdateUserInput } from './types';

/**
 * GraphQL mutation to approve a user
 * Removes pending_user role and keeps business role
 * Uses UPDATE_USER mutation internally
 */
export const APPROVE_USER = gql`
  mutation ApproveUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        databaseId
        name
        email
        username
        roles {
          nodes {
            name
          }
        }
      }
    }
  }
`;

export interface ApproveUserData {
  updateUser: {
    user: User;
  };
}

export interface ApproveUserVariables {
  input: UpdateUserInput;
}
